import Nullstack from 'nullstack';
export default function IconZodiacCapricorn({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zodiac-capricorn",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 4a3 3 0 0 1 3 3v9"
  }), "   ", Nullstack.element("path", {
    d: "M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "17",
    r: "3"
  }), " ");
}